import { type FunctionComponent } from 'react';
import { SearchTag } from '../SearchTag/index.tsx';

import { type SelectOption, type NamedSelectOption } from '../Common/Select/sharedTypes.ts';

type SearchTagType = SelectOption & {
    isActive?: boolean;
};

import styles from './main.scss';

type SearchTagsProps = {
    disabled?: boolean;
    onDelete: (option: NamedSelectOption) => void;
    name: string;
    dataTn?: string;
    tags: SearchTagType[];
    tagSpacing?: 'xSmall' | 'none';
};

export const SearchTags: FunctionComponent<SearchTagsProps> = props => {
    const { disabled, onDelete, name, tags, tagSpacing, dataTn } = props;
    return (
        <div data-tn={dataTn || name} className={styles.searchTagsWrapper}>
            {tags.map(({ label, value, isActive, disabled: tagDisabled }: SearchTagType) => {
                const key = `${dataTn || name}-${value}`;
                const isTagDisabled = disabled || tagDisabled;
                const searchTagProps = {
                    isActive: !isTagDisabled && isActive,
                    disabled: isTagDisabled,
                    onDelete: () => onDelete({ value, label, name }),
                    label,
                    dataTn: key,
                    tagSpacing,
                };
                return (
                    <SearchTag key={key} {...searchTagProps}>
                        {label}
                    </SearchTag>
                );
            })}
        </div>
    );
};
